<template>
    <div class="comments-holder">
        <div class="new-comment">
            <form v-on:submit="addComment">
                <textarea v-model="newComment"></textarea><br>
                <button type="submit" class="new-comment__add-btn">Add comment</button>
            </form>
        </div>
        <div class="comments">
            <div class="comment" v-for="comment of comments" :key="comment._id">
                <span class="comment__date">
                    <template v-if="comment.authorName">
                        {{ comment.authorName }}<template v-if="comment.authorType"> ({{ comment.authorType }})</template>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                    </template>
                    {{ this.formatDate(comment.createdAt) }}
                    <template v-if="comment.updatedAt">
                        &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{{ this.formatDate(comment.updatedAt) }}
                    </template>
                </span>
                <span class="comment__content">{{ comment.content }}</span>
                <span class="comment__actions">
                    <a href="javascript:;" v-on:click="editComment(comment._id, comment.content)">
                        <svg class="svg-icon" style="width: 1.2em; height: 1.2em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M834.3 705.7c0 82.2-66.8 149-149 149H325.9c-82.2 0-149-66.8-149-149V346.4c0-82.2 66.8-149 149-149h129.8v-42.7H325.9c-105.7 0-191.7 86-191.7 191.7v359.3c0 105.7 86 191.7 191.7 191.7h359.3c105.7 0 191.7-86 191.7-191.7V575.9h-42.7v129.8z"  /><path d="M889.7 163.4c-22.9-22.9-53-34.4-83.1-34.4s-60.1 11.5-83.1 34.4L312 574.9c-16.9 16.9-27.9 38.8-31.2 62.5l-19 132.8c-1.6 11.4 7.3 21.3 18.4 21.3 0.9 0 1.8-0.1 2.7-0.2l132.8-19c23.7-3.4 45.6-14.3 62.5-31.2l411.5-411.5c45.9-45.9 45.9-120.3 0-166.2zM362 585.3L710.3 237 816 342.8 467.8 691.1 362 585.3zM409.7 730l-101.1 14.4L323 643.3c1.4-9.5 4.8-18.7 9.9-26.7L436.3 720c-8 5.2-17.1 8.7-26.6 10z m449.8-430.7l-13.3 13.3-105.7-105.8 13.3-13.3c14.1-14.1 32.9-21.9 52.9-21.9s38.8 7.8 52.9 21.9c29.1 29.2 29.1 76.7-0.1 105.8z"  /></svg>
                    </a>&nbsp;&nbsp;
                    <a href="javascript:;" v-on:click="deleteComment(comment._id)">
                        <svg fill="#000000" style="width: 1.2em; height: 1.2em;vertical-align: middle;fill: red;overflow: hidden;"
                                 id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                  viewBox="0 0 482.428 482.429"
                                 xml:space="preserve">
                            <g>
                                <g>
                                    <path d="M381.163,57.799h-75.094C302.323,25.316,274.686,0,241.214,0c-33.471,0-61.104,25.315-64.85,57.799h-75.098
                                        c-30.39,0-55.111,24.728-55.111,55.117v2.828c0,23.223,14.46,43.1,34.83,51.199v260.369c0,30.39,24.724,55.117,55.112,55.117
                                        h210.236c30.389,0,55.111-24.729,55.111-55.117V166.944c20.369-8.1,34.83-27.977,34.83-51.199v-2.828
                                        C436.274,82.527,411.551,57.799,381.163,57.799z M241.214,26.139c19.037,0,34.927,13.645,38.443,31.66h-76.879
                                        C206.293,39.783,222.184,26.139,241.214,26.139z M375.305,427.312c0,15.978-13,28.979-28.973,28.979H136.096
                                        c-15.973,0-28.973-13.002-28.973-28.979V170.861h268.182V427.312z M410.135,115.744c0,15.978-13,28.979-28.973,28.979H101.266
                                        c-15.973,0-28.973-13.001-28.973-28.979v-2.828c0-15.978,13-28.979,28.973-28.979h279.897c15.973,0,28.973,13.001,28.973,28.979
                                        V115.744z"/>
                                    <path d="M171.144,422.863c7.218,0,13.069-5.853,13.069-13.068V262.641c0-7.216-5.852-13.07-13.069-13.07
                                        c-7.217,0-13.069,5.854-13.069,13.07v147.154C158.074,417.012,163.926,422.863,171.144,422.863z"/>
                                    <path d="M241.214,422.863c7.218,0,13.07-5.853,13.07-13.068V262.641c0-7.216-5.854-13.07-13.07-13.07
                                        c-7.217,0-13.069,5.854-13.069,13.07v147.154C228.145,417.012,233.996,422.863,241.214,422.863z"/>
                                    <path d="M311.284,422.863c7.217,0,13.068-5.853,13.068-13.068V262.641c0-7.216-5.852-13.07-13.068-13.07
                                        c-7.219,0-13.07,5.854-13.07,13.07v147.154C298.213,417.012,304.067,422.863,311.284,422.863z"/>
                                </g>
                            </g>
                        </svg>
                    </a>
                </span>
            </div>
        </div>
        <OverlayModal v-if="editCommentId !== null"
            submitText="Update"
            closeText="Cancel"
            @modalSubmitted="modalSubmitted"
            @modalClosed="closeModal">

            <textarea v-model="editCommentContent" class="form-control"></textarea>
        </OverlayModal>
    </div>
</template>

<script>
import OverlayModal from "@/components/global/OverlayModal.vue";

export default {
    name: 'UserComments',
    components: {OverlayModal},
    props: ['userId'],
    data: function() {
        return {
            comments: [],
            newComment: '',
            editCommentId: null,
            editCommentContent: null
        }
    },
    computed: {
        commentsNum() {
          return this.comments.length
        }
    },
    watch: {
        commentsNum(newVal) {
            this.$emit('commentsNumChanged', newVal)
        }
    },
    created() {
        this.loadComments()
    },
    methods: {
        loadComments() {
            this.axios.get(this.apiBase + '/users/' + this.userId + '/comments')
                .then(response => {
                    this.comments = response.data.data.reverse()
                    //console.log(this.comments)
                })
                .catch(error => {
                    alert('Could not load comments!')
                    console.log(error)
                })
        },
        addComment(e) {
            e.preventDefault()
            this.axios.post(this.apiBase + '/users/' + this.userId + '/comments/create', {
                content: this.newComment
            }).then(response => {
                console.log(response)
                this.newComment = ''
                this.loadComments()
            }).catch(error => {
                alert('Error saving comment: ' + error.response.data?.data)
                console.log(error)
            })
        },
        deleteComment(id) {
            if (confirm('Are you sure you want to delete this comment?')) {
                this.axios.delete(this.apiBase + '/users/' + this.userId + '/comments/' + id)
                    .then(() => {
                        //console.log(response)
                        this.loadComments()
                    }).catch(error => {
                    alert('Error deleting comment: ' + error.response.data?.data)
                    console.log(error)
                })
            }
        },
        editComment(id, content) {
            this.editCommentId = id
            this.editCommentContent = content
        },
        modalSubmitted() {
            this.axios.put(this.apiBase + '/users/' + this.userId + '/comments/' + this.editCommentId, {
                content: this.editCommentContent
            }).then(() => {
                //console.log(response)
                this.resetEditData()
                this.loadComments()
            }).catch(error => {
                alert('Error saving comment: ' + error.response.data?.data)
                console.log(error)
            })
        },
        closeModal() {
            this.resetEditData()
        },
        resetEditData() {
            this.editCommentId = null
            this.editCommentContent = null
        }
    }
}
</script>

<style lang="scss" scoped>
.comments-holder {
    display: flex;
    flex-flow: row;
    gap: 20px;
}

.new-comment {
    display: block;
    max-width: 500px;
    width: 100%;
    vertical-align: top;
    margin-bottom: 20px;

    &__add-btn[type="submit"] {
        display: inline-block;
        border: 1px solid #aaa;
        border-radius: 10px;
        padding: 5px 10px;
        color: #555;
        text-decoration: none;
        background: transparent;

        &:hover {
            background: #111;
            color: #f2f2f2;
        }
    }
}
.comments {
    display: block;
    max-width: 500px;
    width: 100%;
    vertical-align: top;
}
.comment {
    display: block;
    background: #e8e8e8;
    border-radius: 15px;
    padding: 10px;
    box-sizing: border-box;
    width: 100%;
    position: relative;
    margin: 20px 0;

    &:first-child {
        margin-top: 0;
    }

    &__date {
        display: block;
        color: #888;
        margin-bottom: 10px;
    }

    &__content {

    }

    &__actions {
        position: absolute;
        top: 10px;
        right: 10px;
    }
}

@media screen and (max-width: 800px) {
    .comments-holder {
        display: block;
    }
}
</style>